<template>
  <modal-container>
    <modal-form-edit
      ref="AccountFormModal"
      title="Account"
      form-component="account-form"
      on-close-clear-query
      hide-delete-button
    >
      <account-partner-info v-if="partner"/>

      <account-payment-method v-if="isCustomer"/>

      <account-invoices/>

      <section-page v-if="!isOnGracePeriod" title="Close Account" is-short>
        <p class="subscription_message">
          If you cancel you will still have access to everything until the end of this billing period.

          <br><br>
          <button-outlined @click="$refs.deleteAccountModal.open()">Close Account</button-outlined>
        </p>
      </section-page>
    </modal-form-edit>

    <close-account-modal ref="deleteAccountModal"/>
  </modal-container>
</template>

<script>
import AccountInvoices from "./components/AccountInvoices";
import AccountPaymentMethod from "./components/AccountPaymentMethod";
import CloseAccountModal from "./components/CloseAccountModal"
import {EventBus} from "../../event-bus";
import {ENUMS} from "../../services/enums";
import AccountPartnerInfo from "./components/AccountPartnerInfo.vue";

export default {
  name: "AccountModal",
  components: {
    AccountPartnerInfo,
    CloseAccountModal,
    AccountInvoices,
    AccountPaymentMethod
  },
  computed: {
    account() {
      return this.$store.getters.account;
    },
    partner() {
      return this.account.partner;
    },
    isCustomer() {
      return this.account.type === ENUMS.AccountTypeEnum.Customer.value;
    },
    isOnGracePeriod() {
      return this.account.status === ENUMS.AccountStatusEnum.GracePeriod.value;
    },
  },
  watch: {
    '$route' () {
      this.openModal();
    },
  },
  mounted() {
    this.openModal();

    EventBus.$on('closeAccountModal', () => {
      this.$refs.AccountFormModal.close();
    });
  },
  methods: {
    openModal() {
      if (this.$route.query.modal === 'account') {
        this.$refs.AccountFormModal.open(this.$store.getters.account);
      }
    },
  }
}
</script>
